<template>
  <v-card class="pa-5 main-grid" :loading="isLoading" :disabled="isLoading">
    <v-toolbar flat dense>
      <v-btn icon @click.stop="navBack">
        <v-icon large>mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title>Document Header Information</v-toolbar-title>
    </v-toolbar>
    <v-form ref="header">
      <v-row>
        <v-col cols="8" md="4" class="py-0">
          <v-text-field
            v-model="documentModel.mci"
            :rules="rules.mci"
            disabled
            class="mx-3"
            style="max-width: 275px"
            label="Document #"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          v-if="documentModel.id"
          class="mt-4 mr-7"
          fab
          small
          color="error"
          @click.stop="deleteHeader"
        >
          <v-icon>mdi-delete-empty</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" class="py-0">
          <product-area
            v-model="documentModel.productArea"
            :product-area-value="documentModel.productArea"
            :rules="rules.productArea"
            class="mx-3"
          ></product-area>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" class="py-0">
          <brand-dropdown
            v-model="documentModel.brand"
            :brand-value="documentModel.brand"
            :rules="rules.brand"
            class="mx-3"
          ></brand-dropdown>
        </v-col>
        <v-col cols="8" md="4" class="py-0">
          <document-type-dropdown
            v-model="documentModel.type"
            :doc-type-value="documentModel.type"
            :rules="rules.docType"
            class="mx-3"
          ></document-type-dropdown>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          class="mt-4 mr-7"
          outlined
          color="primary"
          @click.stop="saveHeader"
          >Save</v-btn
        >
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios';
import router from '../router';
import { mask } from 'vue-the-mask';
import productArea from '@/components/filters/productArea';
import brandDropdown from '@/components/filters/brandDropdown';
import documentTypeDropdown from '@/components/filters/documentTypeDropdown';
import { mapMutations } from 'vuex';

export default {
  name: 'Header',
  directives: { mask },
  components: {
    productArea,
    brandDropdown,
    documentTypeDropdown
  },
  props: {
    documentModel: {
      type: Object,
      default() {
        return {
          mci: '',
          productArea: 0,
          region: 1,
          brand: [0],
          type: 0,
          id: 0
        };
      }
    }
  },
  data() {
    return {
      mciMask: '####-####',
      isLoading: false,
      rules: {
        mci: [v => !!v || 'MCI is required'],
        productArea: [v => !!v || 'Product Area is required'],
        brand: [v => v.length > 0 || 'Brand is required'],
        docType: [v => !!v || 'Document Type is required']
      }
    };
  },
  computed: {
    hasMultipleTranslations() {
      return this.documentModel.translationDocuments.length > 1;
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    clearProductRange() {
      this.documentModel.productRange = 0;
    },
    saveHeader() {
      if (this.$refs.header.validate()) {
        this.isLoading = true;
        let formData = {};
        let method = this.documentModel.id > 0 ? 'put' : 'post';
        let url;
        formData.mci = this.documentModel.mci;
        formData.productArea = this.documentModel.productArea;
        formData.region = 1;
        formData.brand = this.documentModel.brand.map(b => {
          return { brand: b };
        });
        formData.type = this.documentModel.type;
        if (this.documentModel.id > 0) {
          //edit existing
          url = '/Document/' + this.documentModel.id;
        } else {
          //create new
          url = '/Document';
        }

        axios({
          method: method,
          url: url,
          data: formData
        })
          .then(() => {
            this.isLoading = false;
            this.$emit('updated');
            this.showSnackbar({
              text: 'Saved header information',
              color: 'success',
              timeout: 3000
            });
          })
          .catch(error => {
            this.isLoading = false;
            this.showSnackbar({ text: error.response.data, color: 'error' });
          });
      }
    },
    deleteHeader() {
      if (
        confirm(
          'Are you sure you want to delete this header and all translations?'
        )
      ) {
        this.isLoading = true;
        axios
          .delete('/Document/' + this.documentModel.id)
          .then(() => {
            this.isLoading = false;
            this.showSnackbar({
              text: 'Deleted document and all related translations',
              color: 'success',
              timeout: 3000
            });
            router.push('/');
          })
          .catch(error => {
            this.isLoading = false;
            this.showSnackbar({ text: error, color: 'error' });
          });
      }
    },
    navBack() {
      router.go(-1);
    }
  }
};
</script>

<style scoped>
.main-grid {
  min-width: 100%;
}
</style>
